import React from "react";
import "./SpinnerWithLogo.scss";

const SpinnerWithLogo = () => (
  <div className="wrap">
    <div className="spinner"></div>
  </div>
);

export default SpinnerWithLogo;
